
import { MDBAlert, MDBBtn, MDBModalBody, MDBModalFooter, MDBSelect, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { uploadGreeting } from "../../apiclients/streamsapi_bridge";
import ReactRecorder from "../../components/VoiceRecorder/ReactRecorder";

export default function RecordMedia(props) {

    const { t } = useTranslation();
    const [greetingType, setGreetingType] = useState(3);
    const [disableDone, setDisableDone] = useState(true);
    const [failedErrorMessage, setFailedErrorMessage] = useState("");
    const [isloading, setIsloading] = useState(false);

    const [micFileName, setMicFileName] = useState(null);
    const [micRecFile, setMicRecFile] = useState(null);
    const [micName, setMicName] = useState(null);


    useEffect(() => {
        if (micFileName == null || micRecFile == null || micName == null || micFileName == '' || micRecFile == '' || micName == '') {
            setDisableDone(true);
        } else {
            setDisableDone(false);
        }
    }, [micFileName, micRecFile, micName]);

     useEffect(() => {
        if (props.isActive) {
            setFailedErrorMessage("");
            setGreetingType(3);
            setMicFileName(null);
            setMicRecFile(null);
            setMicName(null);
            setDisableDone(true);
        }

    }, [props.isActive]);


    // new Record Media upload.
    async function uploadRecordMedia() {
        try {
            setIsloading(true);
            const formData = new FormData();
            formData.append("siteid", JSON.parse(sessionStorage.getItem("admin_session")).siteid); // The account siteId.
            formData.append("logined_user", JSON.parse(sessionStorage.getItem("admin_session")).logined_user);
            formData.append("greeting_type", greetingType); //  greeting type need to be updated.
            formData.append("greeting", micRecFile); //  file object or the streams data.
            formData.append("filename", micFileName + '.mp3'); // Name of the file.
            formData.append("filetype", ".mp3"); //  type of the file either wav or mp3
            formData.append("uploadtype", 2);
            formData.append("name", micName);

            let apiResponse = await uploadGreeting(formData);
            setTimeout(() => { setIsloading(false) }, 1000);
            let resdata = await apiResponse.json();
            if (apiResponse.status == 200) {
                localStorage.setItem("s_message", resdata.message); // successfully uploaded.
                props.onClose();
                window.location.href = "/medialanding";
            } else if (apiResponse.status === 204 || apiResponse.status === 403 || apiResponse.status === 400 || apiResponse.status === 500) {
                setFailedErrorMessage(resdata.message);
            }
            console.log(`uploadRecordMedia -> JSON Response:${JSON.stringify(resdata)}`);

        } catch (error) {
            console.log(`Unable to  uploadRecordMedia:${error}`);
            setFailedErrorMessage('Internal Server Error');
        }

    }

    return (
        <>
            <MDBModalBody className="p-0">
                {/* <div class="tel-numbers mt-3"><strong>{t("Greeting_Type_txt")}</strong></div>
                <MDBSelect
                    data={[
                        { text: 'MOH_IVR', value: 3 },
                        { text: 'IVR Greeting', value: 4 },
                        { text: 'Announcement Greeting', value: 5 },
                    ]}
                    value={greetingType}
                    onChange={(e) => setGreetingType(e.value)}
                /> */}

                <div class="tel-numbers mt-3"><strong>Record Media</strong></div>
                <div className="mediaPlaylist">

                    <ReactRecorder
                        activeTab={props.isActive} 
                        setMicFileName={setMicFileName}
                        setMicRecFile={setMicRecFile}
                        setMicName={setMicName}
                    />

                </div>
            </MDBModalBody>
            <MDBModalFooter>
                <MDBBtn color='secondary' onClick={props.onClose}>
                    {t("close")}
                </MDBBtn >
                <MDBBtn disabled={disableDone}
                    onClick={(e) => {
                        e.preventDefault();
                        uploadRecordMedia();
                    }}>{t("Done")}</MDBBtn>
            </MDBModalFooter>
            {failedErrorMessage !== "" && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setFailedErrorMessage("")}
                >
                    {failedErrorMessage}
                </MDBAlert>
            )}
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
        </>
    );


}